import { createAction } from 'redux-actions'

const ns = 'auth/'

export const doLogOut = createAction(`${ns}LOG_OUT`)
export const sessionExpired = createAction(`${ns}SESSION_EXPIRED`)
export const accountDeleted = createAction(`${ns}ACCOUNT_DELETED`)
export const clearState = createAction(`${ns}CLEAR_STATE`)

export const getWhoAmI = createAction(`${ns}WHO_AM_I`)
export const getWhoAmISuccess = createAction(`${ns}WHO_AM_I_SUCCESS`)
export const getWhoAmIFail = createAction(`${ns}WHO_AM_I_FAIL`)

export const setOnboardingStatusProfileData = createAction(`${ns}SET_ONBOARDING_STATUS_PROFILE_DATA`)

export const updateLastSync = createAction(`${ns}UPDATE_LAST_SYNC`)

export const updateCompanyBrandLogo = createAction(`${ns}UPDATE_COMPANY_BRAND_LOGO`)
